export const SECOND_PER_MINUTE = 60